import { getToken } from "../utils/auth";
import { images } from "../constants/images";
import { API_BASE_URL } from "./URL_Header";

// Fetch all categories (public endpoint, no token needed)
export const fetchCategories = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/GetAllCategories`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch categories");
    }
    const data = await response.json();
    return data.map((category) => {
      const image = category.imageUrl || images.demoPLP;
      // console.log(`Category: ${category.name}, ImageUrl: ${category.imageUrl ? category.imageUrl : 'Missing'}, Using: ${image}`);
      return {
        id: category.categoryId || null,
        name: category.name || "Unnamed",
        image: image,
        categoryPath: `/category/${category.categoryId || 0}`,
      };
    });
  } catch (err) {
    console.error("Error fetching categories:", err);
    throw new Error(err.message);
  }
};

// Fetch a single category by ID (public endpoint, no token needed)
export const fetchCategoryById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/GetCategory/${id}`
    );
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error("Category not found");
      }
      throw new Error("Failed to fetch category");
    }
    const data = await response.json();
    const image = data.imageUrl || images.demoPLP;
    // console.log(`Category ID: ${data.categoryId}, ImageUrl: ${data.imageUrl ? data.imageUrl : 'Missing'}, Using: ${image}`);
    return {
      id: data.categoryId || null,
      name: data.name || "Unnamed",
      image: image,
      categoryPath: `/category/${data.categoryId || 0}`,
    };
  } catch (err) {
    console.error("Error fetching category:", err);
    throw new Error(err.message);
  }
};

// Fetch designs for a specific category (public endpoint, no token needed)
export const fetchDesignsForCategory = async (id, page = 1, pageSize = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/GetAllDesignsForCategory/${id}?page=${page}&pageSize=${pageSize}`
    );
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error("Category or designs not found");
      }
      throw new Error("Failed to fetch designs for category");
    }
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching designs for category:", err);
    throw new Error(err.message);
  }
};

// Create category (protected endpoint, requires token)
export const createCategory = async (category) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/AddCategory`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken() ? `Bearer ${getToken()}` : undefined,
        },
        body: JSON.stringify({
          name: category.name,
          imageBase64: category.imageBase64,
        }),
      }
    );
    if (!response.ok) {
      throw new Error("Failed to create category");
    }
    const data = await response.json();
    const image = data.imageUrl || images.demoPLP;
    return {
      id: data.categoryId,
      name: data.name,
      image: image,
      categoryPath: `/category/${data.categoryId}`,
    };
  } catch (err) {
    console.error("Error creating category:", err);
    throw new Error(err.message);
  }
};

// Update category (protected endpoint, requires token)
export const updateCategory = async (id, category) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/EditCategory/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken() ? `Bearer ${getToken()}` : undefined,
        },
        body: JSON.stringify({
          name: category.name,
          imageBase64: category.imageBase64, // Send Base64 to backend
        }),
      }
    );
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error("Category not found");
      }
      if (response.status === 400) {
        throw new Error("Invalid category data");
      }
      throw new Error("Failed to update category");
    }
    // Note: EditCategory returns NoContent (204), so we construct the response
    const image = category.imageUrl || images.demoPLP;
    return {
      id,
      name: category.name,
      image: image,
      categoryPath: `/category/${id}`,
    };
  } catch (err) {
    console.error("Error updating category:", err);
    throw new Error(err.message);
  }
};

// Delete category (protected endpoint, requires token)
export const deleteCategory = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/Category/DeleteCategory/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: getToken() ? `Bearer ${getToken()}` : undefined,
        },
      }
    );
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error("Category not found");
      }
      throw new Error("Failed to delete category");
    }
    return { success: true };
  } catch (err) {
    console.error("Error deleting category:", err);
    throw new Error(err.message);
  }
};